import { createSelector } from '@reduxjs/toolkit'
import { CONVENIENCE_TEST_STAGES_ID, ConvenienceTestGroupedSelectedAnswers } from '@repo/user-types'
import { convenienceTestQuestionnaireAnswersSelector } from './convenienceTestQuestionnaireAnswers.selector'

const SELECTED_ANSWER_VALUE = '1'

const STAGES_REQUIRING_SELECTED_ANSWER = new Set([CONVENIENCE_TEST_STAGES_ID.STAGE_1])

const shouldIncludeAnswer = (answer: {
  stage: CONVENIENCE_TEST_STAGES_ID
  answer: string | null
}) => !STAGES_REQUIRING_SELECTED_ANSWER.has(answer.stage) || answer.answer === SELECTED_ANSWER_VALUE

export const groupedSelectedAnswersSelector = createSelector(
  [convenienceTestQuestionnaireAnswersSelector],
  (answers): ConvenienceTestGroupedSelectedAnswers | undefined => {
    if (!answers) return undefined

    return answers.reduce<ConvenienceTestGroupedSelectedAnswers>((acc, answer) => {
      if (!shouldIncludeAnswer(answer)) {
        return acc
      }

      const key =
        answer.stage === CONVENIENCE_TEST_STAGES_ID.STAGE_1
          ? `${answer.stage}-${answer.questionId}`
          : `${answer.stage}-${answer.questionId}-${answer.answerId}`

      acc[key] = answer

      return acc
    }, {})
  },
)
